import React from "react";
import {useMediaQuery} from "react-responsive";
import {Flex, Heading} from "@adobe/react-spectrum";
import LinkButton from "./LinkButton";
import {PHONE_MAX_WIDTH} from "../utils/constants";

function SectionFeedback() {

    const isPhone = useMediaQuery({maxWidth: PHONE_MAX_WIDTH});

    return (
        <Flex direction="column" gap="size-150" alignItems={isPhone ? "stretch" : "start"}>
            <Heading level={2}>How do you explore fonts?</Heading>
            <p className="fs-16">
                This project is part of an innovation strategy to better understand design workflows by making small, publicly-available tools. We would love to know more about how you explore fonts, and we’re happy to keep you in the loop as we iterate, publish thoughts, and launch new prototypes.
            </p>
            <LinkButton text="Get updates and share ideas" href="https://forms.office.com/r/skKbr4bNeA"/>
        </Flex>
    );
}

export default SectionFeedback;